<script setup lang="ts">
  import InfoIcon from '@/shared/assets/icons/InfoIcon.svg';
  import { IconImage } from '@/shared/ui';
  import BulletPoint from './BulletPoint.vue';
</script>

<template>
  <div class="flex flex-col w-full">
    <div class="flex gap-2">
      <IconImage
        :src="InfoIcon"
        alt="Info"
        class="text-gray-03"
      />
      <h2 class="text-gray-03 text-sm font-semibold mb-3">
        Requisitos para adicionar documentos
      </h2>
    </div>
    <p class="mb-3">
      Você pode enviar arquivos através de <span class="font-semibold">Upload</span> ou de
      <span class="font-semibold">URL</span>, para isso, deve selecionar previamente o formato que
      deseja utilizar.
    </p>
    <div class="flex gap-6 ml-3">
      <span>
        <BulletPoint />
        Podem ser enviados arquivos de até
        <span class="font-semibold">10MB.</span>
      </span>
      <span>
        <BulletPoint />
        Podem ser enviados até 10 arquivos por vez.
      </span>
    </div>
  </div>
</template>
